import {
    INoWinSymbolsWPConfig,
    NoWinSymbolsWinPresentationController
} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {RomanEmpireShakeEffect} from "../romanEmpireShakeEffect/RomanEmpireShakeEffect";


export class RENoWinSymbolsWinPresentationController extends NoWinSymbolsWinPresentationController {

    private _isBothWaysWinPresent: boolean = false;
    private _bothWaysWinData: any;

    constructor(indexes: [number, number], config: INoWinSymbolsWPConfig) {
        super(indexes, config);
    }

    /**
     * override this function to dim all non winning symbol when bot ways win is present
     */
    protected hasWin(): boolean {
        return (this._betWinsData != null && this._betWinsData.length > 0 || this._isBothWaysWinPresent);
    }


    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        this._isBothWaysWinPresent = data.bothWayWins.length > 0;
        this._bothWaysWinData = data.bothWayWins;
        super.parseFeatureGameData(data);
    }

    protected getBetLineSymbolWinStates(): void {
        if (this._isBothWaysWinPresent) {
            this._bothWaysWinData.forEach((betLineWinData: IBetLineWinData, index: number) => {
                for (var reelId = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                    var symbolId = betLineWinData.betLine[4 - reelId];
                    if (this._bothWaysWinData[index].winPosition[0]) {
                        this._symbolWinStates[reelId][symbolId] = true;
                        this.updateStackedSymbolWinStates(reelId, symbolId);
                    } else {
                        this._symbolWinStates[4 - reelId][symbolId] = true;
                        this.updateStackedSymbolWinStates(4 - reelId, symbolId);
                    }
                }
            });
        } else {
            super.getBetLineSymbolWinStates();

        }
        RomanEmpireShakeEffect._symbolWinStates=this._symbolWinStates;

    }

    protected stopWinPresentation(isAborted: boolean): void {
        super.stopWinPresentation(isAborted);
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_NO_WIN_PRESENTATION, this._symbolWinStates));
    }
}